import React, { useState } from 'react';
import SmsTableSC from './sms-table.styled';
import Button from '../../ui/button';
import { BodyText, SmallText } from '../../typography';
import Moment from 'react-moment';
import { BP_TABLET_MIN } from '../../../assets/styles/breakpoints';
import useWindowSize from '../../../utils/screen-size';
import WishmakerModal from '../../ui/modal/modal';
import DetailModal from '../detail-modal';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { EmptySC } from '../../investor-mailbox-content/investor-mailbox-content.styled';

const SmsTable = ({ messages, type }) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;
  const [isDetailModalOpened, setDetailModalOpened] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);

  const onSelectDetail = (messageId) => {
    setSelectedDetail(messageId);
    setDetailModalOpened(true);
  };

  if (messages.length < 1) {
    return (
      <EmptySC>
        <div className="empty-table">
          <SmallText className="black-transparent bold">
            <FormattedMessage id="mailbox_sms_empty" defaultMessage={dlt['mailbox_sms_empty']} />
          </SmallText>
        </div>
      </EmptySC>
    );
  }

  return (
    <>
      <WishmakerModal
        isOpened={isDetailModalOpened}
        onClose={() => setDetailModalOpened(false)}
        className="sm"
        withCross
      >
        <DetailModal selectedDetail={selectedDetail} type={type} />
      </WishmakerModal>
      <SmsTableSC>
        <tbody>
          {messages
            ? messages.map((message) => {
                return (
                  <tr key={message.id}>
                    <td>
                      <div className="top-wrap">
                        <span>{message.subject}</span>
                        <BodyText className="black-transparent-lighter">
                          <Moment format="DD. MMMM YYYY">{message.created_at}</Moment>
                        </BodyText>
                      </div>
                      <div className="body-wrap">
                        <BodyText className="black-transparent">{message.short_message}</BodyText>
                      </div>
                      {isTablet ? (
                        <div className="actions-wrap">
                          <div className="actions-wrap--item">
                            <BodyText className="bolder">
                              <FormattedMessage
                                id="mailbox_table_sender"
                                defaultMessage={dlt['mailbox_table_sender']}
                              />
                            </BodyText>
                            <br />
                            <BodyText>{message.sender}</BodyText>
                          </div>
                          <Button type="LINK" onClick={() => onSelectDetail(message.id)}>
                            <FormattedMessage
                              id="mailbox_table_detail_and_documents"
                              defaultMessage={dlt['mailbox_table_detail_and_documents']}
                            />
                          </Button>
                        </div>
                      ) : null}
                    </td>
                    {isTablet ? null : (
                      <td>
                        <div className="actions-wrap">
                          <div className="actions-wrap--item">
                            <BodyText className="bolder">
                              <FormattedMessage
                                id="mailbox_table_sender"
                                defaultMessage={dlt['mailbox_table_sender']}
                              />
                            </BodyText>
                            <br />
                            <BodyText>{message.sender}</BodyText>
                          </div>
                          <Button type="LINK" onClick={() => onSelectDetail(message.id)}>
                            <FormattedMessage
                              id="mailbox_table_detail_and_documents"
                              defaultMessage={dlt['mailbox_table_detail_and_documents']}
                            />
                          </Button>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })
            : null}
        </tbody>
      </SmsTableSC>
    </>
  );
};

export default SmsTable;
